module.exports = __webpack_public_path__ + "media/images/pc/brands/aqua/store_yokohama_ekimae-30c8fc467a38346806f4ea03343cb38c.jpg";